(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_groups/banner-carousel/views/banner-carousel.js') >= 0) return;  svs.modules.push('/components/banner_groups/banner-carousel/views/banner-carousel.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.banner_groups=_svs.banner_groups||{};
_svs.banner_groups.banner_carousel=_svs.banner_groups.banner_carousel||{};
_svs.banner_groups.banner_carousel.templates=_svs.banner_groups.banner_carousel.templates||{};
svs.banner_groups.banner_carousel.templates.banner_carousel = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"components-tb_ui-carousel-carousel"),depth0,{"name":"components-tb_ui-carousel-carousel","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['components-banner_groups-banner_carousel-banner_carousel'] = svs.banner_groups.banner_carousel.templates.banner_carousel;
})(svs, Handlebars);


 })(window);